import { TabStrip, TabStripTab } from '@progress/kendo-react-layout';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { validateUserData } from '../../custom/UserExport';
import UserList from './UserList';
import UserRegisteration from './UserRegisteration';


function UserManagement() {
    const [selected, setSelected] = useState(0)
    const [editDialogVisible, setEditDialogVisible] = useState(false)
    const handleSelect = (e) => {
        setSelected(e.selected);
    }
    const navigate = useNavigate();


    let userData = validateUserData()
    useEffect(() => {
        if (!userData) {
            navigate('/login');
        }
        if (userData?.UserRole !== "ROOT") {
            if (userData) {
                let homeRoute = userData?.routes[0].route ? userData?.routes[0].route : "/"
                navigate(homeRoute);
            }
            else {
                navigate("/login")
            }
        }
    }, [userData, navigate]);

    return (
        <div style={{ height: "100%" }}>
            <div className='usermanage-main-div'>
                <div style={{ width: "100%", height: "100%" }}>
                    <TabStrip selected={selected} onSelect={handleSelect}>
                        <TabStripTab title="User List">
                            <UserList userData={userData} editDialogVisible={editDialogVisible} setEditDialogVisible={setEditDialogVisible} />
                        </TabStripTab>
                        <TabStripTab title="Create New User">
                            <UserRegisteration />
                        </TabStripTab>
                    </TabStrip>
                </div>
            </div>
        </div>
    )
}


export default UserManagement